module.exports = __webpack_public_path__ + "img/thomas-garrett.4aa66cc9.png";